import { atom } from "recoil"

export const outboxContactsConcatRequestIdState = atom({
  key: "atoms/contact/outboxContactsConcatRequestIdState",
  default: 0,
})
